import type { Chain } from '@0xtorch/evm'
import {
  createAbstractChain,
  createApeChain,
  createArbitrumNovaChain,
  createArbitrumOneChain,
  createAstarChain,
  createAvalancheCChain,
  createBaseChain,
  createBerachain,
  createBitTorrentChain,
  createBlastChain,
  createBscChain,
  createCeloChain,
  createClient,
  // createDefiVerseChain,
  createEthereumChain,
  createFantomChain,
  createFraxtalChain,
  createGeekVerseChain,
  createGesoVerseChain,
  createGnosisChain,
  createHomeVerseChain,
  createHyperEvmChain,
  createImmutableZkEvmChain,
  createKatanaChain,
  createLineaChain,
  createMantaPacificChain,
  createMantleChain,
  createMchVerseChain,
  createMchVerseChainCustom,
  createMemeCoreChain,
  createMetisChain,
  createMoonbeamChain,
  createMoonriverChain,
  createOasysChain,
  createOpBnbChain,
  createOptimismChain,
  createPolygonPosChain,
  // createPolygonZkEvmChain,
  createRoninChain,
  createSaakuruChain,
  createScrollChain,
  createSeiChain,
  createSoneiumChain,
  createSonicChain,
  createSophonChain,
  createSwellChain,
  createTaikoChain,
  createUnichain,
  createWorldChain,
  createXdcNetworkChain,
  createZkFairChain,
  createZkSyncEraChain,
  createZoraChain,
  mchVerseHttpRpcs,
} from '@0xtorch/evm'
import { defineChain } from 'viem'

type CreateEvmChainListParameters = {
  proxyApiEndpoint?: string
  etherscanApiKey: string
  fantomApiKey: string
  oasysProxyUrl?: string
  roninApiKey: string
  zkfairProxyUrl?: string
}

export const createEvmChainList = ({
  proxyApiEndpoint,
  etherscanApiKey,
  fantomApiKey,
  oasysProxyUrl,
  roninApiKey,
  zkfairProxyUrl,
}: CreateEvmChainListParameters): readonly Chain[] => [
  createAbstractChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createApeChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createArbitrumNovaChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createArbitrumOneChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createAstarChain({}),
  createAvalancheCChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createBaseChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createBerachain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createBitTorrentChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createBscChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createBlastChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createCeloChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  // createDefiVerseChain({}),
  createEthereumChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createFantomChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: fantomApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createFraxtalChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createGeekVerseChain({}),
  createGesoVerseChain({}),
  createGnosisChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createHomeVerseChain({}),
  createHyperEvmChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createImmutableZkEvmChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createKatanaChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createLineaChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createMantaPacificChain({ explorerProxyUrl: proxyApiEndpoint }),
  createMantleChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  proxyApiEndpoint === undefined
    ? createMchVerseChain({})
    : createMchVerseChainCustom({
        client: createClient({
          chain: defineChain({
            id: 29548,
            name: 'MCH Verse',
            nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
            rpcUrls: {
              default: {
                http: ['https://rpc.oasys.mycryptoheroes.net'],
              },
            },
            blockExplorers: {
              default: {
                name: 'MCH Verse Explorer',
                url: 'https://explorer.oasys.mycryptoheroes.net',
                apiUrl: 'https://explorer.oasys.mycryptoheroes.net/api',
              },
            },
            testnet: false,
          }),
          httpRpcs: mchVerseHttpRpcs.map((rpc) => ({
            ...rpc,
            url: `${proxyApiEndpoint.replace('?url=', '/rpc?url=')}${rpc.url}`,
          })),
        }),
        explorer: createMchVerseChain({}).explorer,
      }),
  createMemeCoreChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createMetisChain({
    explorerProxyUrl: proxyApiEndpoint,
  }),
  createMoonbeamChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createMoonriverChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createOasysChain(
    proxyApiEndpoint === undefined
      ? { explorerProxyUrl: oasysProxyUrl }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createOpBnbChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createOptimismChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createPolygonPosChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  // createPolygonZkEvmChain(
  //   proxyApiEndpoint === undefined
  //     ? { explorerApiKey: etherscanApiKey }
  //     : { explorerProxyUrl: proxyApiEndpoint },
  // ),
  createRoninChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: roninApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createSaakuruChain({}),
  createScrollChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey, explorerPageSize: 1000 }
      : { explorerProxyUrl: proxyApiEndpoint, explorerPageSize: 1000 },
  ),
  createSeiChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createSoneiumChain({}),
  createSonicChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createSophonChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createSwellChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createTaikoChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createUnichain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createWorldChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createXdcNetworkChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createZkFairChain({ explorerProxyUrl: zkfairProxyUrl }),
  createZkSyncEraChain(
    proxyApiEndpoint === undefined
      ? { explorerApiKey: etherscanApiKey }
      : { explorerProxyUrl: proxyApiEndpoint },
  ),
  createZoraChain({}),
]
